import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H2 } from 'foundations-components/transitional/components/H2';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { PanelHeader } from 'foundations-components/transitional/components/PanelHeader';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function EscalationPanelHeader(props) {
  return /*#__PURE__*/_jsxs(PanelHeader, {
    children: [/*#__PURE__*/_jsx(DialogCloseButton, {
      "data-test-id": "escalation-panel-header-close-button",
      onClick: props.onClose
    }), /*#__PURE__*/_jsx(H2, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        "data-test-id": "escalation-panel-header-title",
        message: "app.escalations.panel.header.title"
      })
    })]
  });
}
EscalationPanelHeader.propTypes = {
  onClose: PropTypes.func.isRequired
};
export default EscalationPanelHeader;